import {takeLatest, put} from 'redux-saga/effects';
import {
  CANCEL_USERS_FAILED,
  CANCEL_USERS_SUCCESS,
  CANCEL_USERS,
  GET_USERS_WITH_ID_FAILED,
  GET_USERS_WITH_ID_SUCCESS,
  GET_USERS_WITH_ID,
  GET_USERS_FAILED,
  GET_USERS_SUCCESS,
  GET_USERS,
  UPDATE_USER_FAILED,
  UPDATE_USER_SUCCESS,
  UPDATE_USER,
  CREATE_USER,
  CREATE_USER_FAILED,
  CREATE_USER_SUCCESS,
  UPDATE_USER_STATUS_SUCCESS,
  UPDATE_USER_STATUS_FAILED,
  UPDATE_USER_STATUS,
  GET_CUSTOMERS,
  GET_CUSTOMERS_SUCCESS,
  GET_CUSTOMERS_FAILED,
  GET_ORGANS_SUCCESS,
  GET_ORGANS_FAILED,
  GET_ORGANS,
  POST_ORGANS,
  POST_ORGANS_SUCCESS,
  POST_ORGANS_FAILED,
} from './constants';
import UsersRepository from 'client-sdk/src/Repository/users-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';

export function* getUsers(actions: any): unknown {
  try {
    const {response, count} = yield UsersRepository.getUsers(actions);
    yield put({
      type: GET_USERS_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_USERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* getCustomers(actions: any): unknown {
  try {
    const {response} = yield UsersRepository.getCustomers(actions);
    yield put({
      type: GET_CUSTOMERS_SUCCESS,
      data: response.data,
      // count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_CUSTOMERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* getOrgans(actions: any): unknown {
  try {
    const {response} = yield UsersRepository.getOrgans(actions);
    yield put({
      type: GET_ORGANS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ORGANS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* postOrgans(actions: any): unknown {
  const {callback} = actions.payload;
  try {
    const {response} = yield UsersRepository.postOrgans(actions);
    yield put({
      type: POST_ORGANS_SUCCESS,
      data: response.data,
    });

    callback && callback();
  } catch (error) {
    yield put({
      type: POST_ORGANS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getUserWithId(actions: any): unknown {
  try {
    const response = yield UsersRepository.getUserWithId(actions);
    yield put({
      type: GET_USERS_WITH_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_USERS_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateUser(actions: any): unknown {
  const {pagination, callback} = actions.payload;
  try {
    yield UsersRepository.updateUser(actions);
    yield put({
      type: UPDATE_USER_SUCCESS,
    });
    yield put({
      type: GET_USERS,
      payload: {...pagination},
    });
    callback && callback();
    handleNotfication('کاربر با موفقیت ویرایش شد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_USER_FAILED,
      error: error.response,
    });
    handleNotfication('ویرایش کاربر با خطا مواجه شد', 'error');
    handleError(error.response);
  }
}
export function* createUser(actions: any): unknown {
  const {pagination, callback} = actions.payload;
  try {
    yield UsersRepository.createUser(actions);
    yield put({
      type: CREATE_USER_SUCCESS,
    });
    yield put({
      type: GET_USERS,
      payload: {...pagination},
    });
    callback();
    handleNotfication('کاربر با موفقیت اضافه شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_USER_FAILED,
      error: error.response,
    });
  }
}

export function* updateUserStatus(actions: any): unknown {
  try {
    const {pagination} = actions.payload;
    yield UsersRepository.updateUserStatus(actions);
    yield put({
      type: UPDATE_USER_STATUS_SUCCESS,
    });
    yield put({
      type: GET_USERS,
      payload: {...pagination, sort: 'created,desc'},
    });
  } catch (error) {
    yield put({
      type: UPDATE_USER_STATUS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* cancelUser(actions: any): unknown {
  try {
    yield UsersRepository.cancelUser(actions);
    yield put({
      type: CANCEL_USERS_SUCCESS,
    });
    handleNotfication('کاربر مورد نظر شمابا موفقیت حذف شد', 'success');
  } catch (error) {
    yield put({
      type: CANCEL_USERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* userSaga() {
  yield takeLatest(GET_USERS, getUsers);
  yield takeLatest(GET_CUSTOMERS, getCustomers);
  yield takeLatest(GET_ORGANS, getOrgans);
  yield takeLatest(POST_ORGANS, postOrgans);
  yield takeLatest(GET_USERS_WITH_ID, getUserWithId);
  yield takeLatest(UPDATE_USER, updateUser);
  yield takeLatest(CANCEL_USERS, cancelUser);
  yield takeLatest(CREATE_USER, createUser);
  yield takeLatest(UPDATE_USER_STATUS, updateUserStatus);
}
